import { Row, Col, Card, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useGetHousesQuery } from "../slices/housesApiSlice";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Paginate from "../components/Paginate";
import Meta from "../components/Meta";
import "./productitems.css";
import { useState } from "react";
import SearchBox from '../components/SearchBox';

const CompoundScreen = () => {
    const { pageNumber, keyword } = useParams();
    const { data, isLoading, error } = useGetHousesQuery({
        keyword,
        pageNumber,
    });

    // States for filtering and sorting
    const [filterType, setFilterType] = useState("");
    const [filterAddress, setFilterAddress] = useState("");
    const [sortOption, setSortOption] = useState("");

    // Filter and sorting logic
    const filteredHouses = data?.houses?.filter((house) => {
        return (
            (filterType === "" || house.type === filterType) &&
            (filterAddress === "" || house.address === filterAddress)
        );
    });

    const sortedHouses = filteredHouses?.sort((a, b) => {
        if (sortOption === "price_asc") {
            return a.regularPrice - b.regularPrice;
        } else if (sortOption === "price_desc") {
            return b.regularPrice - a.regularPrice;
        }
        return 0; // Default sorting (no sorting)
    });

    return (
        <>
            {keyword && (
                <Link to="/" className="btn btn-light mb-4">
                    Go Back
                </Link>
            )}
            <div> <SearchBox/> </div>
            {isLoading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">
                    {error?.data?.message || error.error}
                </Message>
            ) : (
                <>
                    <Meta />
                    <h1>BUY OR RENT</h1>

                    {/* Filters and Sorting */}
                    <Form className="mb-4">
                        <Row className="align-items-center">
                            <Col xs={12} md={4}>
                                <Form.Group controlId="filterType">
                                    <Form.Label>Filter by Type</Form.Label>
                                    <Form.Select
                                        value={filterType}
                                        onChange={(e) => setFilterType(e.target.value)}
                                    >
                                        <option value="">Buy Or Rent All</option>
                                        <option value="House For Rent">HOUSE4RENT</option>
                                        <option value="House For Sale">HOUSE4SALE</option>
                                        <option value="Land For Sale">LAND4SALE</option>
                                  
                
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4}>
                                <Form.Group controlId="filterAddress">
                                    <Form.Label>Filter by Address</Form.Label>
                                    <Form.Select
                                        value={filterAddress}
                                        onChange={(e) => setFilterAddress(e.target.value)}
                                    >
                                        <option value="">All Addresses</option>
                                        <option value="Brusubi">Brusubi</option>
                                        <option value="Bakau">Bakau</option>
                                        <option value="Tujereng">Tujereng</option>
                                        <option value="Sukuta">Sukuta</option>
                                        <option value="Sanyang">Sanyang</option>
                                        <option value="Bakoteh">Bakoteh</option>
                                        <option value="Fagikunda">Fagikunda</option>
                                        <option value="Kunkujang">Kunkujang</option>
                                        <option value="Brikama">Brikama</option>
                                        <option value="Banjul">Banjul</option>
                                        <option value="Sanchaba">Sanchaba</option>
                                        <option value="Wellingara">Wellingara</option>
                                        <option value="Yundum">Yundum</option>
                                        <option value="Salagi">Salagi</option>
                                        <option value="SerreKunda">SerreKunda</option>
                                        <option value="CoastalRoad">CoastalRoad</option>
                                        <option value="Kotu">Kotu</option>
                                        <option value="Other">Other</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4}>
                                <Form.Group controlId="sortOption">
                                    <Form.Label>Sort by Price</Form.Label>
                                    <Form.Select
                                        value={sortOption}
                                        onChange={(e) => setSortOption(e.target.value)}
                                    >
                                        <option value="">No Sorting</option>
                                        <option value="price_asc">Price: Low to High</option>
                                        <option value="price_desc">Price: High to Low</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>

                    {/* Display Houses */}
                    <Row>
                        {sortedHouses?.map((house) => (
                            <Col key={house._id} xs={12} sm={6} md={6} lg={3}>
                                <Card className="mb-4 shadow-sm">
                                    {/* Display the first image */}
                                    {house.images && house.images.length > 0 ? (
                                        <Card.Img
                                            variant="top"
                                            src={house.images[0]}
                                            alt={`Property`}
                                            style={{
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    ) : (
                                        <Card.Img
                                            variant="top"
                                            src="https://via.placeholder.com/300"
                                            alt="No image available"
                                            style={{
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    )}
                                    <Card.Body>
                                    <Card.Title>{house.type}</Card.Title>
                                        <Card.Title>{house.name}</Card.Title>
                                        <Card.Text>
                                            <strong>Address:</strong> {house.address}
                                        </Card.Text>
                                        <Card.Text>
                                            <strong>Price:</strong> D{house.regularPrice}
                                            
                                        </Card.Text>
                                        <Card.Text>
                                            
                                            <Link className="btn btn-primary btn-sm m-2" to={`/house/${house._id}`} role="button">More Pictures</Link>
                                            <Link className="btn btn-primary btn-sm m-2" to={"/Contact" } role="button">Contact Us</Link>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <Paginate
                        pages={data.pages}
                        page={data.page}
                        keyword={keyword || ""}
                    />
                </>
            )}
        </>
    );
};

export default CompoundScreen;